<template>
	<NoLineBreaks>
		<Tag v-if="tariffRef == null || !tariffRef.is_active" color="red">
			{{ $t('tariffDisplay.notActive') }}
		</Tag>
		<Tooltip v-if="tariffRef != null" :title="endDatetimeDisplay">
			<InfoCircleOutlined v-if="tariffRef.is_active" />
			{{ tariffRef.title }}
		</Tooltip>
	</NoLineBreaks>
</template>

<script>
import { computed, toRef } from 'vue';
import { Tooltip, Tag } from 'ant-design-vue';
import { InfoCircleOutlined } from '@ant-design/icons-vue';

import { useI18n } from 'vue-i18n';

import { datetimeToString } from '@/components/common/dateUtils';

import NoLineBreaks from '@/components/common/NoLineBreaks';
import Consts from '@/api/Consts';

export default {
	components: {
		Tooltip, Tag, NoLineBreaks, InfoCircleOutlined,
	},
	props: ['tariff'],
	setup(props) {
		const { t } = useI18n();
		const tariffRef = toRef(props, 'tariff');
		const endDatetimeDisplay = computed(() => {
			if (tariffRef.value && tariffRef.value.is_active) {
				return t('tariffDisplay.validUntil', { date: datetimeToString(tariffRef.value.end_datetime) });
			}
			return t('tariffDisplay.notActive');
		});
		return {
			tariffRef,
			endDatetimeDisplay,
			red: Consts.COLORS.errorDark,
		};
	},
}
</script>

<style scoped>
.non-active-icon {
	color: v-bind(red);
}
</style>
